import React from 'react';
import { PRIMARY } from '../../../../theme';
export var Unlock = function Unlock(props) {
  var height = props.height,
      width = props.width;
  width = width ? width : '11';
  height = height ? height : '14';
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.502105",
    y: "5.75314",
    width: "9.53113",
    height: "7.43498",
    rx: "1.92045",
    stroke: props.color || PRIMARY,
    strokeWidth: "0.995789",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74268 5.47711L2.74268 3.6484C2.918 2.57639 3.15565 2.05685 4.14522 1.56745C4.84649 1.22064 5.93877 1.15135 6.77491 1.81969C7.72161 2.5764 7.72161 3.36463 7.72161 3.8691",
    stroke: props.color || PRIMARY,
    strokeWidth: "0.995789",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "0.497895",
    y1: "-0.497895",
    x2: "3.01189",
    y2: "-0.497895",
    transform: "matrix(-9.4701e-06 1 -1 -4.6435e-06 4.60547 7.73853)",
    stroke: props.color || PRIMARY,
    strokeWidth: "0.995789",
    strokeLinecap: "round",
    fill: "none"
  }));
};